import React from "react";
import { Button, Divider, Modal, Spin } from "antd";
import { useSelector } from "react-redux";
import { useActionDialogAdvanceSave } from "hook/draft/dialog/useActionDialogAdvance";
import { draftDialogAdvanceSave } from "store/bailiff/draft/dialog/draft_dialog.selector";
import { LoadingOutlined, WarningOutlined } from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogAdvanceSave = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleCancel, handleSave } = useActionDialogAdvanceSave();
  // -------------------------- STATE ---------------------------

  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogAdvanceSave);
  const open = !!data;

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="flex flex-col gap-3">
        {renderEnterName()}
        {renderFooter()}
      </div>
    );
  };

  const renderEnterName = () => {
    return (
      <div className="flex h-[150px] flex-col items-center justify-center gap-3">
        {loading ? (
          <Spin
            indicator={<LoadingOutlined className="text-orange-500" />}
            spinning
          />
        ) : (
          <WarningOutlined className="text-5xl text-orange-500" />
        )}
        <div className="text-xl font-bold">Xác nhận lưu kết quả này</div>
        <div className="text-center">
          Hành động này không thể phục hồi, vui lòng không đóng hộp thoại để
          tiến trình lưu file được hoàn tất. Xin cám ơn
        </div>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="flex flex-row items-center justify-end gap-2">
        <Button disabled={loading} block onClick={handleCancel}>
          Huỷ
        </Button>
        <Button
          className="bg-orange-600 hover:!bg-orange-700"
          block
          disabled={loading}
          onClick={handleSave}
          type="primary"
        >
          Lưu
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleCancel}
      title={null}
      centered
      closable={false}
      footer={null}
      open={open}
      width={450}
    >
      {renderBody()}
    </Modal>
  );
};
export default DialogAdvanceSave;
